/**
 * Token Helper - Token'ı güvenli şekilde almak için yardımcı fonksiyonlar
 *
 * Bu dosya, Vuex store'un henüz yüklenmediği durumlarda bile
 * localStorage'dan token okuyabilmek için oluşturuldu.
 */

/**
 * Token'ı store'dan veya localStorage'dan güvenli şekilde alır
 *
 * @returns {string|null} Token değeri veya null
 *
 * @example
 * const token = getTokenSafely();
 * if (!token) {
 *   console.error('Token bulunamadı');
 *   return;
 * }
 */
function getTokenSafely() {
  try {
    // Önce localStorage'dan oku (vuex-persistedstate için)
    const vuexState = localStorage.getItem('vuex');
    if (vuexState) {
      const parsedState = JSON.parse(vuexState);
      const token = parsedState?.userData?.token;

      // Token validasyonu
      if (token &&
          typeof token === 'string' &&
          token.trim() !== '' &&
          token !== 'undefined' &&
          token !== 'null') {
        return token;
      }
    }

    return null;
  } catch (error) {
    console.error('❌ [getTokenSafely] Token alınamadı:', error);
    return null;
  }
}

/**
 * Token'ın geçerli olup olmadığını kontrol eder
 *
 * @param {string} token - Kontrol edilecek token
 * @returns {boolean} Token geçerliyse true, değilse false
 *
 * @example
 * if (!isTokenValid(token)) {
 *   throw new Error('Token geçersiz');
 * }
 */
function isTokenValid(token) {
  return token &&
         typeof token === 'string' &&
         token.trim() !== '' &&
         token !== 'undefined' &&
         token !== 'null' &&
         token.length > 10; // JWT minimum uzunluğu
}

/**
 * Token'ı validate eder ve geçersizse hata fırlatır
 *
 * @param {string} token - Validate edilecek token
 * @param {string} functionName - Fonksiyon adı (hata mesajı için)
 * @throws {Error} Token geçersizse hata fırlatır
 *
 * @example
 * validateToken(token, 'calculateCost');
 */
function validateToken(token, functionName = 'Unknown') {
  if (!isTokenValid(token)) {
    console.error(`❌ [${functionName}] Token geçersiz:`, token);
    throw new Error('Token geçersiz veya bulunamadı. Lütfen tekrar giriş yapın.');
  }
}

module.exports = {
  getTokenSafely,
  isTokenValid,
  validateToken
};
